import React, { useContext, useState, useEffect, useRef } from "react";

import { ShareContext } from "../../context/ShareContext";

import { time } from "../../data/time";
import { useNavigate, Link, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import BackLoader from "../../components/backloader";

import moment from "moment";
import JisPreparePdf from "../../components/core/preparepdf";
import DynamicIcon from "../../components/dynamicicon";
import JisPrepareTemplate from "../../components/core/preparetemplate";
import JisButton from "../../components/controls/jisButton";
import JisDialogForm from "../../components/formdialog";
import CaseHeader from "../../components/core/CaseHeader";
import { RefreshCcw } from "lucide-react";

function ReworkPrepareDocument(props) {
  const {
    sweared,
    isCfo,
    isThirdOpt,
    setWhichUpload,
    token,
    profile,
    frequentData,
    setIsExpired,
  } = useContext(ShareContext);
  const { docid } = useParams();
  const { role } = useParams();
  const isLegal = role == "legal" ? true : false;
  const [schedule, setSchedule] = useState({});

  console.log({ isLegal, role });

  //  var profileid=Constants.isServerEnv? Constants.getCookie("profilename"):'seniola1' ;
  const [feeInfo, setFeeInfo] = useState({});
  const url = `${Constants.apiUrl}/filing/rework-document-update/${docid}/${role}`;

  const [isDialog, setIsDialog] = useState(false);
  const [doc, setDocument] = useState({ uplines: [], uplinesigns: [] });
  const [currectdoc, setCurrentDoc] = useState({ upline: null, filenames: [] });
  const [uplineIndex, setUplineIndex] = useState(0);
  const [imgIndex, setImageIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [posPoint, setPosPoint] = useState({}); //this is for items that are yet added passport 1, Seal 2, Signature 3  {x--cord,y - cord,show bool,docid  instype, imgurl}
  const [caseInfo, setCaseInfo] = useState(null);
  const [pageIndex, setPageIndex] = useState(0);
  const [isSaved, setIsSaved] = useState(false);
  const [cashier_seal, setCashierSeal] = useState("");
  const [doctype, setDoctype] = useState("rework");
  const affidavit_search_prefix = "LSJ/HC/AFF";
  //load documents first, then load one by one
  const [posId, setPosId] = useState(0); //this is the main guy that is doing the selection
  const [dstart, setDStart] = useState({ isDragging: false });
  const [imgs, setImgs] = useState([]);
  const [activeFile, setActiveFile] = useState({});

  const [isDocVerified, setIsDocVerified] = useState(false);
  const [imgPrev, setImgPrev] = useState({ data: "", type: "", open: false });
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "" });
  const [prompt, setPrompt] = useState({
    open: false,
    title: "",
    subtitle: "",
  });

  var pageRef = useRef(null);

  const navigate = useNavigate();

  const isCommissioned =
    doc?.uplines?.length > 0 &&
    doc.uplines.every((u) => u.isCompleted === true);

  const onOk = () => {
    setAlert({ ...alert, open: false });
  };
  const retrieveDocYear = () => {
    return currectdoc?.upline?.uploadDate == null
      ? moment(new Date()).format("YYYY")
      : moment(currectdoc?.upline?.uploadDate).format("YYYY");
  };

  useEffect(() => {
    onLoad();
  }, [docid]);


  useEffect(
    () => {
      if (!pageRef.current) {
        // we do not initialize the observer unless the ref has
        // been assigned
        return;
      }

      // we also instantiate the resizeObserver and we pass
      // the event handler to the constructor
      const resizeObserver = new ResizeObserver(() => {
        console.log("in resize observer ");
        const divPos = pageRef.current.getBoundingClientRect();
        const start = {
          initialX: divPos.x,
          initialY: divPos.y,
        };
        console.log("at use effect calculate init position");
        console.log(start);

        setDStart(start);
      });

      // the code in useEffect will be executed when the component
      // has mounted, so we are certain observedDiv.current will contain
      // the div we want to observe
      resizeObserver.observe(pageRef.current);

      // if useEffect returns a function, it is called right before the
      // component unmounts, so it is the right place to stop observing
      // the div
      return function cleanup() {
        resizeObserver.disconnect();
      };
    },
    // only update the effect if the ref element changed
    [pageRef.current],
  );

  const onLoad = async () => {
    //for account registration
    console.log(`the calling url ${url}`);
    try {
      setIsLoading(true);
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setIsLoading(false);
      if (data.code == 0) {
        setDocument({ ...data.doc, uplines: data.uplines });
        //load current first item
        console.log(data, `case info`);
        const _caseinfo = data.caseInfo.caseinfo;
        const division = Constants.getItemById(
          frequentData?.divisions,
          _caseinfo.divisionId,
        )?.title;
        console.log({
          ..._caseinfo,
          division,
          caseType: _caseinfo.caseFilingId == 1 ? "litigation" : "adr",
          type: "document",
        });
        setCaseInfo({
          ..._caseinfo,
          division,
          caseType: _caseinfo.caseFilingId == 1 ? "litigation" : "adr",
          type: "document",
        });
        setUplineIndex(0);
        setImageIndex(0);

        onCurrentDoc(data.uplines[0].id, "upline");
        const _doctype =
          data.doc.caseType == "service-sheriff"
            ? "sheriff"
            : data.doc.caseType;

        //setDoctype(_doctype);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const onCurrentDoc = async (id, ftype) => {
    //doctype=upline always this one
    //for account registration DocumentView
    const url = `${Constants.apiUrl}/filing/singlefile/${id}/${ftype}`;
    setCashierSeal(
      `${Constants.rooturl}/resources/special/cashier_seal_${id}.png`,
    );
    console.log(`the calling url ${url}`);
    try {
      setIsLoading(true);
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setIsLoading(false);
      console.log("specific document");
      console.log(data);
      if (data.code == 0) {
        setCurrentDoc({ ...data }); //filenames[] and upline
        if (data.upline.uplineType == "template") {
          console.log("oncurrentdoc is template ooo");
        }
      } else if (data.code == 1) {
        setCurrentDoc({ ...data }); //this one has template and upline
        if (data.upline.uplineType == "template") {
          console.log("oncurrentdoc is template ooo");
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const onNextFile = () => {
    if (imgs.length > 0 && !isSaved) {
      setAlert({
        ...alert,
        icon: "warning",
        title: "Save Instrument",
        open: true,
        subtitle: `Please save the instrument before you see another document or you drag it off the screen before you continue.`,
        onOk,
      });
      return;
    }

    setIsSaved(false);
    var size = doc.uplines.length;
    setPageIndex(0);
    setImgs([]);
    setPosPoint({});

    if (uplineIndex < size - 1) {
      var a = uplineIndex + 1;
      setUplineIndex(a);
      setImageIndex(0);
      onCurrentDoc(doc.uplines[a].id, "upline");
    } else {
      // alert('What you seeing is the last file');
      setAlert({
        icon: "info",
        open: true,
        title: "Document",
        subtitle: "What you seeing is the last file",
        onOk,
      });
    }
  };

  const onPrevFile = () => {
    if (imgs.length > 0 && !isSaved) {
      setAlert({
        ...alert,
        icon: "warning",
        title: "Save Instrument",
        open: true,
        subtitle: `Please save the instrument before you see another document or you drag it off the screen before you continue.`,
        onOk,
      });
      return;
    }
    setIsSaved(false);
    console.log(uplineIndex);
    setPageIndex(0);
    setImgs([]);
    setPosPoint({});
    if (uplineIndex > 0) {
      var a = uplineIndex - 1;
      setUplineIndex(a);
      setImageIndex(0);
      onCurrentDoc(doc.uplines[a].id, "upline");
    } else {
      //alert('What you seeing is the first file');
      setAlert({
        icon: "info",
        open: true,
        title: "Document",
        subtitle: "What you seeing is the first file",
        onOk,
      });
    }
  };

  const onRefreshUpline = () => {
    onCurrentDoc(currectdoc.upline.id, "upline");
  };
  const onReworkCompleted = () => {
    navigate(`/rework/legalcounsel`);
  }

  //end image rendered

  const onInstumentAppended = (e) => {
    //after saving of instrument, this is what you get
    if (e.code == 0) {
      //saved already
      setImgPrev({ ...imgPrev, open: false });
      setIsSaved(true);
    }
  };
  const onSaveSchedule = (e) => {
    e.preventDefault();
    console.log(schedule);
    var sch = {
      docid: docid,
      zoomLink: schedule.zoom,
      scheduledBy: profile.username,
      scheduleDate: schedule.date + " " + schedule.time,
    };

    const uploadurl = `${Constants.apiUrl}/filing/e-swearing/schedule/${docid}`;

    // Sending the FormData using fetch
    setIsLoading(true);
    fetch(uploadurl, {
      method: "POST",
      body: JSON.stringify(sch),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.code == 0) {
          //saved already
          //first upldate the row and show dialog box

          setSchedule({});

          setAlert({
            open: true,
            title: "Schedule an Appointment",
            subtitle: "Meeting Schedule is successful",
          });
          setIsDialog(false);
          // navigate(-1); //going back
          // navigate(`/cfo-affidavits`);
          navigate(`/cfo-e-swearing`);
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  };

  const goToNextIncomplete = () => {
    if (!doc || !doc.uplines || doc.uplines.length === 0) {
      setAlert({
        open: true,
        title: "Next Document",
        subtitle: "No documents available",
        onOk,
      });
      return;
    }

    const size = doc.uplines.length;
    // try forward from current index
    let foundIndex = -1;
    for (let i = uplineIndex + 1; i < size; i++) {
      const upl = doc.uplines[i] || {};
      // treat as complete if any of these flags are true
      const completed = upl.isCompleted === true;
      if (!completed) {
        foundIndex = i;
        break;
      }
    }

    // if not found ahead, do a full scan from start (skip current)
    if (foundIndex === -1) {
      for (let i = 0; i < size; i++) {
        if (i === uplineIndex) continue;
        const upl = doc.uplines[i] || {};
        const completed = upl.isCompleted === true;
        if (!completed) {
          foundIndex = i;
          break;
        }
      }
    }

    if (foundIndex === -1) {
      setAlert({
        open: true,
        title: "Next Document",
        subtitle: "No more incomplete documents found",
        onOk,
      });
      return;
    }

    // navigate to that upline
    setUplineIndex(foundIndex);
    setImageIndex(0);
    setIsSaved(false);
    onCurrentDoc(doc.uplines[foundIndex].id, "upline");
  };

  return (
    <div className="view-doc">
      <div className="body" style={{ width: "100%" }}>
        <div className="document-navigation-btn">
          <CaseHeader />
        </div>

        <div className="top-nav">
          <div className="left-top">
            <div className="top">
              <h3>Prepare Document (Rework). Requested by {doc.requestby}: <div>{doc.comment}</div>{doctype}</h3>

              <div onClick={onRefreshUpline}>
                <DynamicIcon iname="refresh" />
                <RefreshCcw className="icon" />
              </div>
            </div>
          </div>
          
        </div>
        <div className="summary document-summary">
          <div>
            <p className="summary-label">Reference ID</p>
            <p className="summary-value">
              {doctype == "affidavit"
                ? `${affidavit_search_prefix}/${
                    currectdoc?.upline?.id
                  }/${retrieveDocYear()}`
                : `${caseInfo?.caseNumber}/HC/${currectdoc?.upline?.id}`}
            </p>
          </div>

          {doctype != "affidavit" && (
            <>
              <div>
                <p className="summary-label">Number of Document</p>
                <p className="summary-value">{doc?.uplines.length}</p>
              </div>
              <div>
                <p className="summary-label">Scheduled for E-Swearing</p>
                <p className="summary-value">
                  {doc.schedule == null ? "No" : "Yes"}
                </p>
              </div>
            </>
          )}

          {/* {doc.schedule!=null && <>
        <div><strong>e-Swearing Schedule Date</strong><br /> {doc.schedule==null?'N/A':Constants.formatDate(doc.schedule)}</div>
        <div><strong>e-Swearing Schedule Time</strong><br />{doc.schedule==null?'N/A':Constants.formatTime(doc.schedule)} </div>
        <div><strong>Zoom Link</strong><br />{doc.zoomLink!=null && <a href={doc.zoomLink} target='_blank'>{doc.zoomLink}</a>} </div> 
    </>} */}

        {/*   {doc.uplines.length > 1 && currectdoc.upline?.documentTitle && (
            <div className="document-navigation">
              <button onClick={onPrevFile} className="btn-solid">
                Previous
              </button>
              <div className="namedoc">
                <p className="document-navigation-label">
                  {currectdoc.upline?.documentTitle}
                </p>
              </div>
              <button onClick={onNextFile} className="btn-solid">
                Next
              </button>
            </div>
          )} */}
        </div>
        {currectdoc?.upline != null &&
          currectdoc.upline.uplineType != "template" && (
            <JisPreparePdf
              pdfdoc={currectdoc}
              docInfo={caseInfo}
              isLegal={isLegal}
              onInstumentAppended={onInstumentAppended}
              doctype={doctype}
              scheduleButtonText={
                doc.schedule == null ? "Schedule Case" : "Reschedule Case"
              }
              onSchedule={() => setIsDialog(true)}
              onGoToNextIncomplete={goToNextIncomplete}
              isCommissioned={isCommissioned}
              isDocVerified={isDocVerified}
              onReplace={onReworkCompleted}
            />
          )}
        {currectdoc?.upline != null &&
          currectdoc.upline.uplineType == "template" && (
            <JisPrepareTemplate
              templatedoc={currectdoc}
              docInfo={caseInfo}
              isLegal={isLegal}
              onInstumentAppended={onInstumentAppended}
              doctype={doctype}
              isCfo={role === "cfo"}
              scheduleButtonText={
                doc.schedule == null ? "Schedule Case" : "Reschedule Case"
              }
              onSchedule={() => setIsDialog(true)}
              onGoToNextIncomplete={goToNextIncomplete}
              isCommissioned={isCommissioned}
              isDocVerified={isDocVerified}
            />
          )}
      </div>

      {isDialog && (
        <JisDialogForm title="Schedule" onClose={() => setIsDialog(false)}>
          <form onSubmit={onSaveSchedule}>
            <div>
              <div className="input-group">
                <label> Zoom Link</label>
                <div className="input-wrapper">
                  <DynamicIcon iname="chair_alt" />
                  <input
                    type="url"
                    placeholder="Zoom Link"
                    value={schedule.zoom}
                    onChange={(e) =>
                      setSchedule({ ...schedule, zoom: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="input-group">
                <label> Zoom meeting date</label>
                <div className="input-wrapper">
                  <DynamicIcon iname="chair_alt" />
                  <input
                    type="date"
                    placeholder="Zoom meeting date"
                    value={schedule.date}
                    onChange={(e) =>
                      setSchedule({ ...schedule, date: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="input-group">
                <label> Zoom meeting time</label>
                <div className="input-wrapper">
                  <DynamicIcon iname="chair_alt" />
                  <input
                    type="time"
                    placeholder="Zoom meeting time"
                    value={schedule.time}
                    onChange={(e) =>
                      setSchedule({ ...schedule, time: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="schedule_btn_wrapper">
                <button variant={"outline"} onClick={() => setIsDialog(false)}>
                  Cancel
                </button>
                <button type="submit">Schedule Appointment</button>
              </div>
            </div>
          </form>
        </JisDialogForm>
      )}
      <BackLoader open={isLoading} />
    </div>
  );
}

export default ReworkPrepareDocument;
